/**
 * Map the phase names emitted by our state machine → the keys the soundpack
 * admin panel uses. The soundpacks pilots upload cover these 8 phases:
 *   BOARDING · PUSHBACK · INFLIGHT · TURBULENCE
 *   DESCENT  · APPROACH · ARRIVAL  · DEPLANING
 * Phases without a good mapping just don't fire a clip.
 */
export const PHASE_TO_SOUND_KEY = {
  "BOARDING": "BOARDING",
  "TAXI OUT": "PUSHBACK",
  "CRUISE":   "INFLIGHT",
  "DESCENT":  "DESCENT",
  "APPROACH": "APPROACH",
  "TAXI IN":  "ARRIVAL",
  "ARRIVED":  "DEPLANING",
};

/**
 * The order a flight meets its announcements in. A clip plays only when the
 * flight has moved past every clip already reached, so each one is heard at
 * most once per flight and never out of order: a phase that wobbles back
 * (a level-off mid-descent read as cruise, reported 2026-10-04; a go-around
 * back into APPROACH) cannot replay the cruise service or the descent PA.
 * TURBULENCE is played by hand only, so it is not in the order.
 */
export const SOUND_ORDER = ["BOARDING", "PUSHBACK", "INFLIGHT", "DESCENT", "APPROACH", "ARRIVAL", "DEPLANING"];

/** The sound key a new phase should play, and the flight's new furthest point;
 *  key is null when nothing should play. `reached` is -1 at the start of a flight. */
export function nextSound(phase, reached) {
  const key = PHASE_TO_SOUND_KEY[phase] || phase;
  const at = SOUND_ORDER.indexOf(key);
  return at > reached ? { key, reached: at } : { key: null, reached };
}

// The arrival PA waits for taxi speed. TAXI IN starts at touchdown, so it used
// to play on the landing roll (beta report 2026-10-07).
export const ARRIVAL_BELOW_KT = 25;

/** The phase the announcements follow: TAXI IN only once slowed to taxi
 *  speed. `active.spd` is ground speed in knots. */
export function soundPhase(phase, active) {
  if (phase === "TAXI IN" && (Number(active?.spd) || 0) >= ARRIVAL_BELOW_KT) return null;
  return phase;
}
